export class RESOURCE_TYPES {
  static readonly PDF = 'pdf';
  static readonly VIDEO = 'video';
  static readonly IMAGE = 'image';
  static readonly WEB = 'web';
}
